import React from "react"

import { Field } from "formik"

import { Select } from "@unlimint/admin-ui-kit"

export const SelectField = ({
  name,
  label,
  placeholder,
  disabled,
  options,
  multiple = false,
}) => {
  return (
    <Field name={name}>
      {({ field, form: { errors } }) => {
        const isEmptyOptions = !options?.length
        return (
          <Select
            options={options}
            name={name}
            disabled={disabled || isEmptyOptions}
            onChange={field.onChange}
            placeholder={placeholder}
            header={label}
            error={!!errors[name]}
            helperText={errors[name]}
            defaultValue={!isEmptyOptions && field.value}
            multiple={multiple}
          />
        )
      }}
    </Field>
  )
}
